<template>
    <FieldGroup__base_wrap
        :fieldGroup_class="fieldGroup_class"
        :fieldGroup_label_class="fieldGroup_label_class"
        :fieldGroup_info_class="fieldGroup_info_class"
        :id="id"
        :label="label"
        :info="info"
        :disabled="disabled"
        :error="error"
        :warning="warning"
    >
        <div class="input-group"><!-- 'input-group'!!! -->
            <flat-pickr
                class="field-group__input"
                :class="fieldGroup_input_class"
                :id="id"
                :name="id"
                :placeholder="placeholder_text"
                :disabled="disabled"
                :config="config"
                @onOpen="onOpen"
                @onClose="onClose"
                v-model="date"
            >
            </flat-pickr>
            <span class="field-group__icon icon"
                  v-if="icon"
                  data-toggle=""
            >
                <span class="icon__symbol"><SvgIcon class="icon" :name="icon"/></span>
            </span>
        </div>
    </FieldGroup__base_wrap>
</template>
<script>
    import flatPickr from "vue-flatpickr-component";
    import 'flatpickr/dist/flatpickr.css';
    // theme is optional
    // try more themes at - https://flatpickr.js.org/themes/
    import 'flatpickr/dist/themes/material_blue.css';
    // localization is optional
    import {english} from "flatpickr/dist/l10n/default.js"
    import {Spanish} from "flatpickr/dist/l10n/es.js"
    import {Portuguese} from "flatpickr/dist/l10n/pt.js"
    import {mapGetters} from "vuex";
    import {AlgerianArabic} from "flatpickr/dist/l10n/ar-dz";
    import {convertDateRangeToArray} from "@/lib/lib";
    import moment from "moment/moment";

    export default {
        name: 'FieldGroup_flatpickr',
        emits:['update:modelValue'],
        props: {
            fieldGroup_class: {
                type: [String, Array, Object],
                default: () => ''
            },
            fieldGroup_label_class: {
                type: [String, Array, Object],
                default: () => ''
            },
            fieldGroup_input_class: {
                type: [String, Array, Object],
                default: () => ''
            },
            fieldGroup_info_class: {
                type: [String, Array, Object],
                default: () => ''
            },
            id: String,
            label: {
                type: String,
                default: () => { return '' }
            },
            modelValue: [String, Object, Array],
            placeholder: String,
            error: {
                type: [String, Array, Object],
                default: () => ''
            },
            warning: {
                type: [String, Array, Object],
                default: () => ''
            },
            info: String,
            input_icon: String,
            maxDate: [String, Number],
            minDate: [String, Number],
            daysLimitMax: [String, Number],
            daysLimitMin: [String, Number],
            defaultDate: [String, Array],
            rangeMode: {
                type: Boolean,
                default: () => false,
            },
            disabled: {
                type: Boolean,
                default: () => false,
            }
        },
        components: {
            flatPickr,
        },
        data() {
            return {
                // Get more form https://flatpickr.js.org/options/
                // Get more form https://flatpickr.js.org/examples/
                def_config: {
                    wrap: true, // set wrap to true only when using 'input-group'
                    altFormat: 'M j, Y',
                    altInput: true,
                    dateFormat: 'Y-m-d',
                    //locale: Hindi, // locale for this instance only
                    onChange: null,
                },
                locales: {
                    'en': english,
                    'es': Spanish,
                    'pt': Portuguese,
                    'ar': AlgerianArabic,
                },
                localeDate: '',
                controlOpen: false
            }
        },
        computed: {
            ...mapGetters([
                "getDateFormatAll",
            ]),
            date:{
              get() {
                  return (this.controlOpen && this.rangeMode) ? this.localeDate : this.modelValue;
              },
              set(val) {
                  this.localeDate = val
              }
            },
            locale() {
                return this.$i18n.locale
            },
            allDateRange() {
                return convertDateRangeToArray(this.date)
            },
            minRangeDate() {
                return this.daysLimitMin ? moment(this.allDateRange[0]).add(this.daysLimitMin, 'days').format('YYYY-MM-DD') : undefined;
            },
            maxRangeDate() {
                let maxDate = this.daysLimitMin ? moment(this.allDateRange[0]).add(this.daysLimitMax, 'days').format('YYYY-MM-DD') : undefined;
                return maxDate && (maxDate > this.getDateToday) ? this.getDateToday : maxDate
            },
            minFilterDate() {
                if(this.controlOpen && !this.date) {
                    return this.minDate
                } else
                if(this.minRangeDate && this.minRangeDate < this.minDate) {
                    return this.minDate
                } else {
                    return this.minRangeDate || this.minDate
                }
            },
            maxFilterDate() {
                if(this.controlOpen && !this.date) {
                    return this.maxDate
                } else
                if(this.maxRangeDate && this.maxRangeDate > this.maxDate) {
                    return this.maxDate
                } else {
                    return (this.maxRangeDate || this.maxDate)
                }
            },
            config() {
                let altFormat = this.getDateFormatAll.altFormat || 'M j, Y'
                let config = {...this.def_config, altFormat}
                config.locale = this.locales[this.locale]
                if(this.rangeMode) config.mode = 'range';
                if(this.defaultDate) config.defaultDate = this.defaultDate
                config.minDate = this.minFilterDate
                config.maxDate = this.maxFilterDate
                return config
            },
            placeholder_text() {
                return this.placeholder ? this.placeholder :
                    this.$t('text.Enter') + ' ' + this.label.toLowerCase()
            },
            icon() {
                return this.input_icon ? this.input_icon : 'input__date'
            }
        },
        watch: {
            modelValue: {
                handler: function (value) {
                    if(!this.controlOpen && value != this.localeDate) {
                        this.localeDate = value
                    }
                },
                immediate: true,
            },
        },
        methods: {
            onChange(/*selectedDates, dateStr, instance*/) {
                //console.log(selectedDates, dateStr, instance)
            },
            onOpen(/*selectedDates, dateStr, instance*/) {
                // console.log(selectedDates, dateStr, instance)
                this.controlOpen = true
                this.localeDate = ''
            },
            onClose(selectedDates, dateStr /*, instance*/) {
                //console.log(selectedDates, dateStr, instance);
                this.controlOpen = false;
                this.localeDate = this.rangeMode ? (dateStr || this.modelValue) : dateStr
                this.$emit('update:modelValue', this.localeDate)
            },
        },
        created() {
        },
        mounted() {
        },
        updated() {
            //console.log('FieldGroup_input updated', this.id, this.error)
        },
    }
</script>
<style lang="scss" scoped>
.hide-label{
    .field-group__icon {
        top: 16px;
    }
}
.field-group__icon {
    top: 16px;
    &.icon {
        svg {
            width: 1rem;
            height: 1rem;
            color: var(--flatpicker-icon-color)
        }
    }
}
</style>
<style lang="scss">
.hide-label{
    .input-group {
        .field-group__input {
            padding: 5px 10px;
            height: auto;
        }
    }
}
.prometheus-portal {
    .flatpicker-timeline {
        .field-group__input {
            border-radius: 36px;
            font-size: 12px;
            cursor: pointer;
        }
        .field-group__input{
            color: var(--playback-select-color);
            background: var(--playback-select-bg);
            border: none;

            &:hover,
            &:focus{
                border: none;
            }
        }
        .field-group__icon {
            &.icon {
                $iconSize: 16px;
                z-index: 1;
                width: $iconSize;
                height: $iconSize;
                .icon__symbol svg {
                    width: $iconSize;
                    height: $iconSize;
                }
            }
            .icon__symbol svg {
                color: var(--playback-select-icon-color);
            }
        }
    }
    .track-list-pm-date-picker {
        width: 160px;
        border-radius: 17px;
        &.field-group {
            background: var(--track-list-pm-date-picker-background);
        }
        .field-group__input {
            border-radius: 17px;
            font-size: 12px;
            border: var(--track-list-pm-date-picker-border);
        }
    }
}
</style>
